import {GenericEntity} from './generic-entity.model';

export class Claims extends GenericEntity {
    policyNumber: string;
    claimsSummary: ClaimsSummary;
    installmentsSummary: InstallmentsSummary;
    subscriptionList: PolicySubscription[];
}

export class ClaimsSummary {
    acceptedClaimsAmount: number;
    dismissedClaimsAmount: number;
    claims: ClaimIdentity[];
}

export class ClaimIdentity {
    claimNumberInEis: string;
    claimNumberTU: string;
    mode: string;
    status: string;
    eventDate: string;
    reportDate: string;
    paymentsSum: number;
}

export class InstallmentsSummary {
    numberOfInstalments: number;
    numberOfInstalmentsPaid: number;
    totalRepayments: number;
    paymentStatus: string;
}

export class PolicySubscription {
    sequenceNo: number;
    paymentDate: string;
    amount: number;
    paid: boolean;
}
